import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from '@headlessui/react'
import { X } from "react-bootstrap-icons";

export default function Drawer({ isOpen, title, toggle, children, size = "sm", elevated = false }) {

  const width = () => {
    switch (size) {
      case "sm":
        return 520;
      case "md":
        return 720;
      case "lg":
        return 1120
      default:
        return 520;
    };
  };

  return (
    <Dialog open={isOpen} onClose={toggle} className={`relative ${elevated ? "z-[70]" : "z-40"}`}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-zinc-500/50 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
      />
      <div className="fixed inset-0" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className={`pointer-events-none fixed inset-y-0 right-0 flex w-[${width()}px]`}>
            <DialogPanel
              transition
              className={`pointer-events-auto w-full transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700`}
            >
              <div className="flex h-full w-full flex-col bg-white shadow-xl">
                <div className="py-4 px-5 border-b border-zinc-200 flex items-start justify-between">
                  <DialogTitle className="text-base font-semibold text-zinc-900">{title}</DialogTitle>
                  <button
                    type="button"
                    onClick={toggle}
                    className="relative h-8 rounded-md bg-white text-zinc-400 hover:text-zinc-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
                  >
                    <span className="sr-only">Close panel</span>
                    <X size={20} aria-hidden="true" className="" />
                  </button>
                </div>
                {children}
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export function DrawerBody({ children }) {
  return (
    <div className="flex-1 flex flex-col overflow-y-auto">
      {children}
    </div>
  )
}

export function DrawerFooter({ children }) {
  return (
    <div className="shrink-0 mt-auto px-4 py-3 border-t border-zinc-200 flex gap-4">
      {children}
    </div>
  )
}
